import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  interactive?: boolean;
}
export const Card = ({
  children,
  className = '',
  onClick,
  interactive = false
}: CardProps) => {
  return <div className={`
        border border-gray-200 p-6 rounded-lg shadow-sm bg-white 
        ${interactive ? 'cursor-pointer hover:border-primary hover:shadow-md transition-all' : ''} 
        ${className}
      `} onClick={interactive ? onClick : undefined} data-id="element-1453" data-mp="2hy2vf992rnbb">
      {children}
    </div>;
};